import React, { useEffect } from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import PlaceSearch from './PlaceSearch';

function PlaceSearchList(props) {
  const { placesSearch } = props;

  const initLoading = () => {};

  useEffect(initLoading, []);

  return (
    <div className="company-list section">
      <div className="title-section">PlacesSearch</div>
      {placesSearch.map((placeSearch, index) => {
        return <PlaceSearch key={placeSearch.id} placeSearch={placeSearch} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(PlaceSearchList);
